import type { Theme } from '../types/Theme'

export function resolveSystemTheme(): Exclude<Theme, 'system'> {
  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
  const prefersHighContrast = window.matchMedia(
    '(prefers-contrast: more)'
  ).matches

  if (prefersDark && prefersHighContrast) return 'dark-hc'
  if (prefersDark) return 'dark'
  if (prefersHighContrast) return 'light-hc'
  return 'light'
}
